import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "clientes" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "col-name" }
const _hoisted_6 = { class: "col-doc" }
const _hoisted_7 = { class: "col-doc" }
const _hoisted_8 = { class: "col-address" }
const _hoisted_9 = { class: "col-city" }
const _hoisted_10 = { class: "col-phone" }
const _hoisted_11 = { class: "col-phone" }
const _hoisted_12 = { class: "actions-cell" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "modal"
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-row" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "form-row" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "form-actions" }
const _hoisted_33 = { class: "modal-content notice-modal" }
const _hoisted_34 = { class: "modal-actions" }
const _hoisted_35 = { class: "modal-content notice-modal" }
const _hoisted_36 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationControls = _resolveComponent("PaginationControls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showModal = true)),
        class: "btn btn-success"
      }, [...(_cache[22] || (_cache[22] = [
        _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
        _createTextVNode(" Novo Cliente ", -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "col-name" }, "Nome Completo"),
            _createElementVNode("th", { class: "col-doc" }, "RG"),
            _createElementVNode("th", { class: "col-doc" }, "CPF"),
            _createElementVNode("th", { class: "col-address" }, "Endereço"),
            _createElementVNode("th", { class: "col-city" }, "Cidade"),
            _createElementVNode("th", { class: "col-phone" }, "Telefone 1"),
            _createElementVNode("th", { class: "col-phone" }, "Telefone 2"),
            _createElementVNode("th", { class: "col-actions" }, "Ações")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clientes, (cliente) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: cliente.id
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(cliente.fullName), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(cliente.rg || '-'), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString($setup.formatCPF(cliente.cpf)), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString($setup.formatEnderecoCompleto(cliente)), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(cliente.city), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString($setup.formatPhone(cliente.phone1)), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(cliente.phone2 ? $setup.formatPhone(cliente.phone2) : '-'), 1),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: ($event: any) => ($setup.editarCliente(cliente)),
                  class: "btn-action edit",
                  title: "Editar"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                ]))], 8, _hoisted_13),
                _createElementVNode("button", {
                  onClick: ($event: any) => ($setup.deletarCliente(cliente.id)),
                  class: "btn-action delete",
                  title: "Deletar"
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                ]))], 8, _hoisted_14)
              ])
            ]))
          }), 128)),
          ($setup.clientes.length === 0 && !$setup.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("td", {
                  colspan: "8",
                  class: "no-data"
                }, "Nenhum cliente cadastrado", -1)
              ]))]))
            : _createCommentVNode("", true),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("td", {
                  colspan: "8",
                  class: "no-data"
                }, "Carregando...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_PaginationControls, {
      limit: $setup.limit,
      offset: $setup.offset,
      "page-items-count": $setup.pageItemsCount,
      onPrev: $setup.onPrevPage,
      onNext: $setup.onNextPage
    }, null, 8, ["limit", "offset", "page-items-count", "onPrev", "onNext"]),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h2", null, _toDisplayString($setup.editingId ? 'Editar Cliente' : 'Cadastrar Novo Cliente'), 1),
            _createElementVNode("form", {
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => ($setup.salvarCliente && $setup.salvarCliente(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { for: "fullName" }, "Nome Completo *", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "fullName",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.novoCliente.fullName) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, $setup.novoCliente.fullName]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { for: "rg" }, "RG", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "rg",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.novoCliente.rg) = $event)),
                  onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.formatRG && $setup.formatRG(...args))),
                  maxlength: "12",
                  placeholder: "00.000.000-0"
                }, null, 544), [
                  [_vModelText, $setup.novoCliente.rg]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { for: "cpf" }, "CPF (11 dígitos) *", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "cpf",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.novoCliente.cpf) = $event)),
                  onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.formatCPFInput && $setup.formatCPFInput(...args))),
                  maxlength: "14",
                  placeholder: "000.000.000-00",
                  required: ""
                }, null, 544), [
                  [_vModelText, $setup.novoCliente.cpf]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { for: "phone1" }, "Telefone 1 *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "phone1",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.novoCliente.phone1) = $event)),
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.formatPhoneInput && $setup.formatPhoneInput(...args))),
                    maxlength: "15",
                    placeholder: "(00) 00000-0000",
                    required: ""
                  }, null, 544), [
                    [_vModelText, $setup.novoCliente.phone1]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "phone2" }, "Telefone 2", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "phone2",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.novoCliente.phone2) = $event)),
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.formatPhone2Input && $setup.formatPhone2Input(...args))),
                    maxlength: "15",
                    placeholder: "(00) 00000-0000"
                  }, null, 544), [
                    [_vModelText, $setup.novoCliente.phone2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { for: "street" }, "Rua *", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "street",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.novoCliente.street) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, $setup.novoCliente.street]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { for: "number" }, "Número *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "number",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.novoCliente.number) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, $setup.novoCliente.number]
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { for: "complement" }, "Complemento", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "complement",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.novoCliente.complement) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.novoCliente.complement]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { for: "neighborhood" }, "Bairro *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "neighborhood",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.novoCliente.neighborhood) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, $setup.novoCliente.neighborhood]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { for: "city" }, "Cidade *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "city",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.novoCliente.city) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, $setup.novoCliente.city]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[39] || (_cache[39] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-success"
                }, [
                  _createElementVNode("i", { class: "fas fa-save" }),
                  _createTextVNode(" Salvar ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.cancelar && $setup.cancelar(...args)))
                }, [...(_cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1),
                  _createTextVNode(" Cancelar ", -1)
                ]))])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showNoticeModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal",
          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => ($setup.showNoticeModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_33, [
            _cache[40] || (_cache[40] = _createElementVNode("h2", null, "Aviso", -1)),
            _createElementVNode("p", null, _toDisplayString($setup.noticeMessage), 1),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.showNoticeModal = false))
              }, " Fechar ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal",
          onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => ($setup.fecharDeleteModal && $setup.fecharDeleteModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_35, [
            _cache[41] || (_cache[41] = _createElementVNode("h2", null, "Confirmar exclusão", -1)),
            _cache[42] || (_cache[42] = _createElementVNode("p", null, "Tem certeza que deseja deletar este cliente?", -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($setup.fecharDeleteModal && $setup.fecharDeleteModal(...args)))
              }, " Cancelar "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => ($setup.confirmarDeleteCliente && $setup.confirmarDeleteCliente(...args)))
              }, " Deletar ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}